import { makeStyles } from "@material-ui/core/styles";
import myTheme from "../../themes/palette"
export const useStyles = makeStyles((theme) => ({

	appBar: {
		// position: "relative",
		background: "#FFF",
	},
	logo: {
		width: "120px",
		marginLeft: theme.spacing(2),
	},
	layout: {
		width: "auto",
		marginLeft: theme.spacing(2),
		marginRight: theme.spacing(2),
		[theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
			width: 600,
			marginLeft: "auto",
			marginRight: "auto",
		},
		marginTop:152,
		[theme.breakpoints.down(myTheme.breakpoints.values.xmd)]: {
		  marginTop:164,
		},
		[theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
		  marginTop:160,
		},
	},
	paper: {
		marginTop: theme.spacing(12),
		marginBottom: theme.spacing(3),
		padding: theme.spacing(2),
		[theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
			marginTop: theme.spacing(12),
			// marginBottom: theme.spacing(6),
			padding: theme.spacing(3),
		},
	},
	buttons: {
		marginTop: theme.spacing(2),
		display: "flex",
		justifyContent: "center",
	},
	button: {
		marginTop: theme.spacing(3),
		marginLeft: theme.spacing(1),
	},
	headingMargin: {
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(4),
	},
}));
